export default function SinglePhaseIcon({ ...props }) {
  return (
    <svg viewBox="0 0 22 6" {...props}>
      <path d="m 1 2 c -0.55 0 -1 0.45 -1 1 s 0.45 1 1 1 h 4 v 2 h 6 v -6 h -6 v 2 z m 14 4 c 1.3 -0 2.4 -0.84 2.82 -2 h 4.18 v -2 h -4.18 c -0.42 -1.16 -1.52 -2 -2.82 -2 h -2 v 6 z"></path>
    </svg>
  );
}
